import { render } from "./newsSide.vue?vue&type=template&id=012f7d1c&scoped=true"
import script from "./newsSide.vue?vue&type=script&lang=js"
export * from "./newsSide.vue?vue&type=script&lang=js"

import "./newsSide.vue?vue&type=style&index=0&id=012f7d1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012f7d1c"]])

export default __exports__